
import mainblock from './mainblock.js'
import minies from './minies.js'
import media from './media.js'

const state = {
        
    color:'#fff',
    name:'Eingabe',
    showminies: false,
    showmedia: false,
    vuexnamespace: 'recipesteps',
    initmutation:'recipesteps/RECIPESTEP_INIT_RECIPESTEP',
    backlink:'entities',   
    duplicateable:true,
    helptext:"Hier werden die Daten für einen einzelnen Rezeptschritt erfasst. <br> \n\
            Die Menge wird in kg angegeben. Die Maßeinheit (kann später geändert werden\n\
            ist derzeit auch nur in kg. <br>\n\
            Über das Lupensymbol wird die Zutat/ das Rezept gesucht und ausgewählt. Das \n\
            Suchdialog-Feld kann innerhalb der Liste via Schlagworten als auch in der Volltextsuche \n\
            suchen. <br> Die Zubereitung kann über das Plus-Symbol um weitere Angaben ergänzt werden."

    
};

export default {
    namespaced: true,
    modules: {
        mainblock: mainblock,
        minies:minies,
        media:media        
    },
    state,
  
};